import firebaseConfig from '@/firebase.sdkConfig.json';

export function getFirebaseConfig() {
  return {
    ...firebaseConfig,
    apiKey: import.meta.env.DEV
      ? import.meta.env.VITE_API_KEY || firebaseConfig.apiKey
      : firebaseConfig.apiKey,
  };
}
